import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

const BestSelers = ({ menu }) => {
    const [menuReady, setMenuReady] = useState([]);
    const [featuredMenu, setFeaturedMenu] = useState([]);

    useEffect(() => {
        menu.menu.then(response => {
            setMenuReady(response.items);
        });

        getFeaturedItems(menuReady);
    }, [menuReady]);

    const getFeaturedItems = menu => {
        let filteredMenu = menu.filter(item => item.fields.category === "pizza");
        return filteredMenu.map(item => {
            let featuredItem;
            if (item.fields.id === 54) {
                featuredItem = (
                    <h6 className="ribbon-cont">
                        <div className="ribbon primary" />
                        <b>OFFER</b>
                    </h6>
                );
            } else if (item.fields.id === 78) {
                featuredItem = (
                    <h6 className="ribbon-cont">
                        <div className="ribbon secondary" />
                        <b>SPECIALITY</b>
                    </h6>
                );
            } else {
                featuredItem = null;
            }
            return (
                <div className="col-lg-3 col-md-4  col-sm-6 " key={item.fields.id}>
                    <div className="center-text mb-30">
                        <div className="ïmg-200x mlr-auto pos-relative">
                            {featuredItem}
                            <img
                                src={item.fields.image.fields.file.url}
                                alt={item.fields.image.fields.description}
                            />
                        </div>
                        <h5 className="mt-20">{item.fields.name}</h5>
                        <h4 className="mt-5">
                            <b>{item.fields.price} czk</b>
                        </h4>
                        <h6 className="mt-20">
                            <a href="#" className="btn-brdr-primary plr-25">
                                <b>Order Now</b>
                            </a>
                        </h6>
                    </div>
                </div>
            );
        });
    };

    return (
        <section className="story-area bg-seller color-white pos-relative">
            <div className="pos-bottom triangle-up" />
            <div className="pos-top triangle-bottom" />
            <div className="container">
                <div className="heading">
                    <img className="heading-img" src="images/heading_logo.png" alt="" />
                    <h2>Best Sellers</h2>
                </div>

                <div className="row">
                    {menuReady && getFeaturedItems(menuReady)}
                    {/* <div className="col-lg-3 col-md-4  col-sm-6 ">
                        <div className="center-text mb-30">
                            <div className="ïmg-200x mlr-auto pos-relative">
                                <img
                                    src="../../assets/images/seller-2-200x200.png"
                                    alt=""
                                />
                            </div>
                            <h5 className="mt-20">Pizza Margherita</h5>
                            <h4 className="mt-5">
                                <b>$11.90</b>
                            </h4>
                            <h6 className="mt-20">
                                <a href="#" className="btn-brdr-primary plr-25">
                                    <b>Order Now</b>
                                </a>
                            </h6>
                        </div>
                    </div> */}

                    {/* <div className="col-lg-3 col-md-4  col-sm-6 ">
                        <div className="center-text mb-30">
                            <div className="ïmg-200x mlr-auto pos-relative">
                                
                                <img
                                    src="../../assets/images/seller-2-200x200.png"
                                    alt=""
                                />
                            </div>
                            <h5 className="mt-20">Pizza Margherita</h5>
                            <h4 className="mt-5">
                                <b>$11.90</b>
                            </h4>
                            <h6 className="mt-20">
                                <a href="#" className="btn-brdr-primary plr-25">
                                    <b>Order Now</b>
                                </a>
                            </h6>
                        </div>
                    </div> */}
                </div>

                <h6 className="center-text mt-40 mt-sm-20 mb-30">
                    <a href="#" className="btn-primaryc plr-25">
                        <b>SEE TODAYS MENU</b>
                    </a>
                </h6>
            </div>
        </section>
    );
};

const mapStateToProps = ({ menu }) => ({
    menu: menu
});

export default connect(
    mapStateToProps,
    null
)(BestSelers);
